(() => {
  var slideIndex = 1;

  // Next/previous controls
  function plusSlides(n) {
    showSlides((slideIndex += n));
  }

  // Thumbnail image controls
  function currentSlide(n) {
    showSlides((slideIndex = n));
  }

  function showSlides(n) {
    var i;
    var slides = document.getElementsByClassName('mySlides');
    var dots = document.getElementsByClassName('dot');

    //console.log('slides'+ slides);
    //console.log('slides length'+ slides.length);
    if (n > slides.length) {
      slideIndex = 1;
    }
    if (n < 1) {
      slideIndex = slides.length;
    }
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = 'none';
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(' active', '');
    }
    //console.log('slideIndex'+ slideIndex);
    slides[slideIndex - 1].style.display = 'block';
    dots[slideIndex - 1].className += ' active';
  }

  function getid(e) {
    var targ;
    if (e.target) {
      targ = e.target;
    } else if (e.srcElement) {
      targ = e.srcElement;
    }
    if (targ.nodeType === 3) {
      // get round Safari bug
      targ = targ.parentNode;
    }
    if (targ.id === '') {
      targ = targ.parentNode;
    }
    return targ.id;
  }

  function klap(e) {
    var id, n;
    e = e || window.event;
    id = getid(e);
    if (/^slidedot/.test(id)) {
      n = +id.slice(8);
      currentSlide(n);
    } else if (id === 'slideprev') {
      plusSlides(-1);
    } else if (id === 'slidenext') {
      plusSlides(1);
    }
  }

  document.addEventListener('click', klap, false);

  showSlides(slideIndex);
})();
